import { RootEpic } from 'typesafe-actions';

import { createPaginatedGetEpic } from '../utils';
import { getAccountDelegationsAsync } from './actions';

export const loadDelegations: RootEpic = (
  action$,
  state$,
  { getPaginatedAccountDelegationsSubscription }
) =>
  createPaginatedGetEpic(
    action$,
    getAccountDelegationsAsync,
    getPaginatedAccountDelegationsSubscription
  );
